import { render, staticRenderFns } from "./IconTextButton.vue?vue&type=template&id=360f2f6d&scoped=true&"
import script from "./IconTextButton.vue?vue&type=script&lang=js&"
export * from "./IconTextButton.vue?vue&type=script&lang=js&"
import style0 from "./IconTextButton.vue?vue&type=style&index=0&id=360f2f6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f2f6d",
  null
  
)

export default component.exports